import React from 'react';
import gameAudio from '../../tools/gameAudio';

class GameResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDetails: false,
            animatedStars: 0,
        };
    }

    componentDidMount() {
        // Animate stars appearing one by one
        const { stars } = this.props;
        for (let i = 1; i <= stars; i++) {
            setTimeout(() => {
                this.setState({ animatedStars: i });
                gameAudio.starEarned(i - 1);
            }, i * 300);
        }
        // New record fanfare
        if (this.props.isNewRecord) {
            setTimeout(() => gameAudio.newRecord(), stars * 300 + 200);
        }
    }

    render() {
        const {
            levelId, levelName, stats, stars,
            previousBest, isNewRecord,
            onRetry, onNextLevel, onQuit,
            hasNextLevel,
        } = this.props;

        const { showDetails, animatedStars } = this.state;

        const nearMissThreshold = previousBest ? previousBest - stats.score : null;
        const showNearMiss = !isNewRecord && nearMissThreshold !== null && nearMissThreshold > 0 && nearMissThreshold < 500;

        return (
            <div className="game-results" data-testid="results-screen">
                {/* Stars */}
                <div className="results-stars" data-testid="star-rating">
                    {[1, 2, 3].map(i => (
                        <span
                            key={i}
                            className={`result-star ${animatedStars >= i ? 'star-filled' : 'star-empty'}`}
                        >
                            ★
                        </span>
                    ))}
                </div>

                <h2 className="results-title">
                    {stats.isEndless ? 'Endless Complete!' :
                     stats.isDaily ? 'Daily Challenge Complete!' :
                     levelName ? `Level ${levelId} Complete!` : 'Game Over'}
                </h2>

                {/* New record */}
                {isNewRecord && (
                    <div className="results-record">
                        🏆 NEW RECORD! {previousBest ? `${previousBest.toLocaleString()} → ` : ''}{stats.score.toLocaleString()}
                    </div>
                )}

                {/* Near-miss framing */}
                {showNearMiss && (
                    <div className="results-nearmiss">
                        Just {nearMissThreshold} points from your best!
                    </div>
                )}

                {/* Main stats */}
                <div className="results-stats-grid">
                    <div className="results-stat">
                        <div className="stat-value">{stats.score.toLocaleString()}</div>
                        <div className="stat-label">Score</div>
                    </div>
                    <div className="results-stat">
                        <div className="stat-value">{Math.round(stats.accuracy * 100)}%</div>
                        <div className="stat-label">Accuracy</div>
                    </div>
                    <div className="results-stat">
                        <div className="stat-value">{stats.bestCombo}x</div>
                        <div className="stat-label">Best Combo</div>
                    </div>
                    <div className="results-stat">
                        <div className="stat-value">{stats.avgReactionTime ? stats.avgReactionTime + 'ms' : '-'}</div>
                        <div className="stat-label">Avg Reaction</div>
                    </div>
                </div>

                {/* Secondary stats */}
                <div className="results-secondary">
                    Targets: {stats.targetsHit}/{stats.totalTargets}
                    {stats.decoyTaps > 0 && <span> · Decoy taps: {stats.decoyTaps}</span>}
                </div>

                {/* Break suggestion — non-intrusive, after 5+ consecutive games */}
                {stats.consecutiveGames >= 5 && stats.consecutiveGames % 5 === 0 && (
                    <div className="break-suggestion" data-testid="break-suggestion">
                        Nice session! Look at something far away for 20 seconds.
                    </div>
                )}

                {/* Action buttons — in thumb zone */}
                <div className="results-actions">
                    <button
                        className="results-btn results-btn-secondary"
                        data-testid="retry-button"
                        onClick={onRetry}
                    >
                        Retry
                    </button>
                    {hasNextLevel && (
                        <button
                            className="results-btn results-btn-primary"
                            data-testid="next-level-button"
                            onClick={onNextLevel}
                        >
                            Next Level →
                        </button>
                    )}
                    {!hasNextLevel && (
                        <button
                            className="results-btn results-btn-primary"
                            onClick={onQuit}
                        >
                            Done
                        </button>
                    )}
                </div>

                {/* Details toggle — eye training stats hidden by default */}
                <button
                    className="results-details-toggle"
                    data-testid="show-details"
                    onClick={() => this.setState({ showDetails: !showDetails })}
                >
                    {showDetails ? '▴ Hide Details' : '▾ Show Details'}
                </button>

                {showDetails && (
                    <div className="results-details">
                        <div>Best Reaction: {stats.bestReactionTime ? stats.bestReactionTime + 'ms' : '-'}</div>
                        <div>PERFECT hits: {stats.perfectHits || 0}</div>
                        {stats.goldenHits > 0 && <div>Golden hits: {stats.goldenHits}</div>}
                    </div>
                )}

                {/* New achievements earned this session */}
                {stats.newAchievements && stats.newAchievements.length > 0 && (
                    <div className="results-achievements" data-testid="new-achievements">
                        {stats.newAchievements.map(a => (
                            <div key={a.id} className="achievement-badge">
                                <span className="achievement-icon">🏅</span>
                                <span className="achievement-name">{a.name}</span>
                                <span className="achievement-desc">{a.desc}</span>
                            </div>
                        ))}
                    </div>
                )}

                {/* Back to levels link */}
                <a href="/focusCatcher" className="results-back-link" onClick={(e) => { e.preventDefault(); onQuit(); }}>
                    Back to Levels
                </a>
            </div>
        );
    }
}

export default GameResults;
